import * as Styled from '../../policy.styled';

function TermsOfServiceTh() {
  return (
    <Styled.MainWrapper>
      <h3>บทที่ 1 บททั่วไป</h3>
      <p>ข้อที่ 1 วัตถุประสงค์</p>ข้อกำหนดและเงื่อนไขการใช้บริการฉบับนี้ มีวัตถุประสงค์เพื่อกำหนดสิทธิ หน้าที่
      และความรับผิดชอบต่าง ๆ ระหว่างผู้ใช้บริการกับบริษัท บับเบิ้ลแท็ป จำกัด (ต่อไปนี้เรียกว่า “บริษัท”)
      ที่เกี่ยวข้องกับการใช้บริการทั้งหมดที่บริษัทให้บริการ เช่น Tingle, Reward และบริการอื่น ๆ ที่เกี่ยวข้อง
      (เรียกรวมว่า “บริการ”)
      <br />
      <br />
      โดยการใช้งานบริการที่บริษัทจัดให้ ถือว่าผู้ใช้ (อ้างอิงในข้อที่ 2 คำนิยาม) ได้ยอมรับ
      และตกลงตามเงื่อนไขการให้บริการและนโยบายต่าง ๆ ที่บริษัทกำหนดแล้ว
      <p>ข้อที่ 2 นิยาม</p>
      <ol>
        ① คำศัพท์ที่ใช้ในข้อกำหนดและเงื่อนไขฉบับนี้ ให้มีความหมายดังต่อไปนี้
        <li> “ผู้ใช้” หมายถึง ทั้งสมาชิกและบุคคลทั่วไปที่เข้ามาใช้บริการที่บริษัทให้บริการ</li>
        <li>
          “สมาชิก” หมายถึง บุคคลที่ได้ยินยอมตามข้อตกลงนี้ รวมถึงยินยอมให้ข้อมูลส่วนบุคคล และได้รับสิทธิ์ในการใช้บริการ
        </li>
        <li>
          “คอนเทนต์” หมายถึง เนื้อหาทั้งหมดที่ถูกโพสต์หรือให้บริการโดยเกี่ยวข้องกับบริการที่บริษัทให้บริการ
          ซึ่งรวมถึงทุกองค์ประกอบที่จัดทำหรือสร้างขึ้นโดยใช้ปัญญาประดิษฐ์ (AI) เช่น ตัวละคร โครงเรื่อง ธีม เอกสาร
          ข้อความ ภาพถ่าย ข้อมูล ภาพนิ่ง วิดีโอ โน้ตเสียง ดนตรี งานออกแบบ อัลกอริธึม คำสั่งข้อความ (Prompt) เป็นต้น
          (เรียกรวมว่า “แอสเซต”) ทั้งหมดนี้ถือเป็นส่วนหนึ่งของคอนเทนต์
        </li>
        <li>“ข้อความที่ป้อนเข้า” หมายถึง ข้อความที่ผู้ใช้ป้อนเพื่อใช้บริการ Tingle และใช้งานแอสเซต</li>
        <li>“ข้อความผลลัพธ์” หมายถึง ข้อความที่ระบบของ Tingle สร้างขึ้นโดยอ้างอิงจากข้อความที่ผู้ใช้ป้อน</li>
        <li> “บริการแบบชำระเงิน” หมายถึง คอนเทนต์และบริการต่าง ๆ ที่บริษัทให้บริการในรูปแบบเสียค่าใช้จ่าย</li>
        <li>
          “อุปกรณ์ที่ใช้เข้าถึง” หมายถึง อุปกรณ์ต่าง ๆ เช่น คอมพิวเตอร์ โทรศัพท์มือถือ แท็บเล็ต
          และอุปกรณ์ฮาร์ดแวร์อื่นใดที่ใช้เข้าถึงข้อมูลหรือคอนเทนต์ ไม่จำกัดเฉพาะอุปกรณ์ที่มีอยู่ในปัจจุบันเท่านั้น
        </li>
        <li>
          “โพสต์” หมายถึง ข้อมูลหรือเนื้อหาทุกรูปแบบที่สมาชิกโพสต์ลงในบริการขณะใช้งาน ซึ่งอาจอยู่ในรูปของสัญลักษณ์
          ตัวอักษร ข้อความ รูปภาพ เสียง ภาพเคลื่อนไหว วิดีโอ รวมถึงไฟล์และลิงก์ต่าง ๆ ที่แสดงผลเป็นบทความ รูปวาด ภาพถ่าย
          วิดีโอ หรือสื่อประเภทอื่น ๆ ทั้งนี้ ยังรวมถึงข้อความแนะนำ คำอธิบาย รูปภาพ คำโปรย หรือเนื้อหาอื่น ๆ
          ที่สมาชิกสร้างขึ้นเพื่อใช้ผลิตหรือสร้างคอนเทนต์ด้วยระบบปัญญาประดิษฐ์ (AI) บนแพลตฟอร์มของบริษัท
        </li>
        <li>
          “สกุลเงินภายในระบบ” หมายถึง สกุลเงินเสมือนที่สมาชิกสามารถรับ สะสม
          หรือซื้อได้ภายในแอปพลิเคชันหรือแพลตฟอร์มที่บริษัทจัดให้
        </li>
        <li>
          สกุลเงินภายในระบบนี้สามารถใช้เป็นสื่อกลางในการแลกเปลี่ยนเพื่อรับบริการแบบชำระเงินต่าง ๆ บริษัทมีให้ในแอปได้
        </li>
        ② สำหรับคำศัพท์อื่นที่ไม่ได้ระบุไว้ในข้อที่ 1 ให้อ้างอิงตามข้อกำหนดการใช้บริการเฉพาะด้าน คู่มือการใช้งาน
        กฎหมายที่เกี่ยวข้อง หรือแนวทางปฏิบัติโดยทั่วไป
      </ol>
      <p>ข้อที่ 3 การให้ข้อมูลเกี่ยวกับบริษัท</p>
      บริษัทจะแสดงข้อมูลเกี่ยวกับของบริษัท ได้แก่ นโยบายการคุ้มครองข้อมูลส่วนบุคคล ชื่อบริษัท ชื่อของผู้แทนบริษัท
      ที่อยู่ หมายเลขโทรศัพท์ ที่อยู่อีเมล เลขทะเบียนธุรกิจ หมายเลขใบอนุญาตประกอบธุรกิจพาณิชย์อิเล็กทรอนิกส์
      และข้อมูลติดต่อฝ่ายบริการลูกค้า ไว้อย่างชัดเจนในหน้าแรกของบริการ เพื่อให้สมาชิกสามารถตรวจสอบได้
      <p>ข้อที่ 4 การเผยแพร่และการแก้ไขข้อกำหนดและเงื่อนไขการใช้บริการ</p>
      <ol>
        ① บริษัทจะเผยแพร่ข้อกำหนดและเงื่อนไขนี้ไว้ในหน้าแรกของบริการ หรือแสดงผ่านหน้าต่างป๊อปอัป
        เพื่อให้สมาชิกสามารถตรวจสอบได้โดยง่าย <br /> <br /> ② บริษัทสามารถแก้ไขข้อกำหนดและเงื่อนไขฉบับนี้ได้
        โดยต้องไม่ละเมิดต่อกฎหมายที่เกี่ยวข้อง เช่น พระราชบัญญัติส่งเสริมการใช้เครือข่ายสารสนเทศและการคุ้มครองข้อมูล
        พระราชบัญญัติคุ้มครองผู้บริโภคในธุรกรรมพาณิชย์อิเล็กทรอนิกส์ หรือ พระราชบัญญัติควบคุมข้อสัญญาที่ไม่เป็นธรรม
        <br /> <br /> ③ เมื่อบริษัททำการแก้ไขข้อกำหนดและเงื่อนไข จะต้องระบุวันที่มีผลบังคับใช้
        และเหตุผลในการแก้ไขไว้อย่างชัดเจน พร้อมกับเผยแพร่ข้อกำหนดเดิมและข้อกำหนดที่แก้ไขแล้วตามวิธีในข้อที่ 1 อย่างน้อย
        7 วันก่อนวันที่มีผลบังคับใช้
        <br />
        ในกรณีที่การแก้ไขส่งผลเสียต่อตัวสมาชิก บริษัทจะต้องแจ้งให้ทราบล่วงหน้าอย่างน้อย 30 วันก่อนวันบังคับใช้
        และใช้วิธีการสื่อสารผ่านช่องทางอิเล็กทรอนิกส์ เช่น อีเมลหรือป๊อปอัปภายในบริการ เพื่อแจ้งเตือนสมาชิกโดยตรง
        <br /> <br />
        ④ บริษัทได้แจ้งอย่างชัดเจนว่า หากสมาชิกไม่แสดงเจตนาปฏิเสธภายในระยะเวลา 7 หรือ 30
        วันแล้วจะถือว่ายินยอมตามข้อกำหนดที่แก้ไข และสมาชิกไม่ได้แสดงการปฏิเสธอย่างชัดเจนภายในระยะเวลาดังกล่าว
        จะถือว่าสมาชิกได้ยินยอมต่อข้อกำหนดและเงื่อนไขฉบับที่แก้ไขแล้วโดยอัตโนมัติ
        <br /> <br /> ⑤ หากสมาชิกไม่ยินยอมให้ใช้ข้อกำหนดและเงื่อนไขที่แก้ไข
        บริษัทจะไม่สามารถใช้ข้อกำหนดฉบับใหม่กับสมาชิกดังกล่าวได้ และสมาชิกมีสิทธิ์ยกเลิกสัญญาการใช้งาน
        <br />
        อย่างไรก็ตาม หากบริษัทมีเหตุผลพิเศษที่ไม่สามารถดำเนินการต่อภายใต้ข้อกำหนดเดิมได้
        บริษัทมีสิทธิ์ยกเลิกสัญญาการใช้งานกับสมาชิกได้เช่นกัน
      </ol>
      <p>ข้อที่ 5 การตีความข้อกำหนดและเงื่อนไขของข้อตกลง</p>
      ① บริษัทอาจกำหนดข้อตกลงหรือเงื่อนไขในการใช้บริการเพิ่มเติมแยกต่างหากจากข้อตกลงฉบับนี้ (เรียกว่า
      “ข้อตกลงเพิ่มเติม”) หากเนื้อหาในข้อตกลงเพิ่มเติมขัดแย้งกับข้อตกลงฉบับนี้
      ให้ถือว่าข้อตกลงเพิ่มเติมมีผลบังคับใช้ก่อน <br />
      <br />
      ② สำหรับกรณีที่ข้อตกลงฉบับนี้ไม่ได้กำหนดไว้ หรือมีข้อสงสัยในการตีความ ให้เป็นไปตามข้อตกลงเพิ่มเติม
      กฎหมายที่เกี่ยวข้อง หรือแนวปฏิบัติทั่วไปในสังคม <br />
      <br />③
      สำหรับบริการแบบชำระเงินที่บริษัทได้รับอนุญาตจากเจ้าของลิขสิทธิ์หรือผู้ให้บริการเนื้อหาเพื่อนำมาให้สมาชิกใช้งาน
      รายละเอียดของบริการดังกล่าวอาจอยู่ภายใต้กฎหมายหรือสนธิสัญญาของประเทศต้นทางของผู้ให้บริการเนื้อหา
      <p>ข้อที่ 6 การทำสัญญาการใช้บริการ</p>
      <ol>
        ① สัญญาการใช้บริการจะถือว่ามีผลเมื่อผู้ใช้เริ่มใช้บริการที่บริษัทให้บริการ สำหรับผู้ที่ต้องการสมัครสมาชิก(
        ต่อไปจะเรียกว่า “ผู้สมัคร”) สัญญาจะมีผลเมื่อผู้สมัครได้แสดงความยินยอมต่อข้อกำหนดฉบับนี้และยื่นคำขอสมัครสมาชิก
        และบริษัทได้อนุมัติคำขอดังกล่าว
        <br /> <br />
        ② โดยทั่วไป บริษัทจะอนุมัติคำขอสมัครสมาชิก อย่างไรก็ตาม บริษัทสามารถปฏิเสธหรือยกเลิกสัญญาได้ภายหลัง
        หากมีกรณีดังต่อไปนี้ เด็กอายุต่ำกว่า 14 ปีไม่ได้รับความยินยอมจากผู้ปกครองหรือผู้แทนโดยชอบธรรม
        ไม่สามารถอนุมัติได้เนื่องจากความผิดพลาดหรือปัญหาที่เกิดจากตัวผู้ใช้ ใช้ชื่อปลอมหรือใช้ชื่อบุคคลอื่นในการสมัคร
        เคยถูกเพิกถอนสิทธิการเป็นสมาชิกจากบริษัท มีพฤติกรรมที่ขัดต่อเงื่อนไขในข้อตกลงฉบับนี้หรือกฎหมายที่เกี่ยวข้อง
        <br /> <br />
        ③ สำหรับการสมัครตามข้อที่ 1 บริษัทอาจขอให้มีการยืนยันตัวตนหรือการตรวจสอบชื่อจริงผ่านหน่วยงานที่เกี่ยวข้อง
        <br /> <br />
        ④ หากบริษัทมีข้อจำกัดด้านอุปกรณ์ระบบ ปัญหาทางเทคนิค หรือเหตุผลด้านธุรกิจ อาจเลื่อนการอนุมัติการสมัครได้
        <br /> <br />
        ⑤ ในกรณีที่ไม่สามารถอนุมัติหรือเลื่อนการอนุมัติการสมัครสมาชิกได้ตามข้อที่ 2 หรือข้อที่ 4
        บริษัทจะต้องแจ้งให้ผู้สมัครสมาชิกทราบ
        <br /> <br />
        ⑥ เวลาที่สัญญาการใช้บริการถือว่าเกิดขึ้น คือ ขณะระบบแสดงผลว่าสมัครสมาชิกเสร็จสมบูรณ์ สำหรับบริการแบบชำระเงิน
        จะถือว่าสัญญาเริ่มต้นเมื่อระบบแสดงผลว่าการชำระเงินสำเร็จ
        <br /> <br />
        ⑦ บริษัทอาจกำหนดเงื่อนไขการใช้งานที่แตกต่างกันตามระดับสมาชิก เช่น ระยะเวลาในการใช้งาน จำนวนครั้งที่ใช้งาน
        เมนูบริการ ตามนโยบายของบริษัท
        <br /> <br />
        ⑧ บริษัทสามารถจำกัดการใช้งานหรือแบ่งประเภทเนื้อหาตามระดับอายุ เพื่อให้เป็นไปตามกฎหมาย เช่น กฎหมายคุ้มครองเยาวชน
        หรือกฎหมายเกี่ยวกับภาพยนตร์และวิดีโอ และอาจกำหนดให้มีการยืนยันตัวตนผู้ใหญ่ก่อนใช้งานเนื้อหาบางประเภท
        <br /> <br />
        ⑨ สมาชิกที่ต้องการใช้บริการแบบชำระเงินจะต้องยอมรับข้อตกลงฉบับนี้ รวมถึงข้อตกลงเพิ่มเติมที่เกี่ยวข้อง
        และชำระค่าบริการตามเงื่อนไขที่บริษัทกำหนด
        <br /> <br />
        ⑩ หากสมาชิกเป็นผู้เยาว์อายุต่ำกว่า 19 ปี และต้องการใช้บริการแบบชำระเงิน บริษัทจะต้องแจ้งให้ทราบก่อนทำสัญญาว่า
        หากไม่ได้รับความยินยอมจากผู้ปกครอง หรือไม่ได้รับการยืนยันภายหลังการทำสัญญา
        ผู้เยาว์หรือผู้ปกครองสามารถยกเลิกสัญญานั้นได้
        <br />
      </ol>
      <p>ข้อที่ 7 การเปลี่ยนแปลงข้อมูลสมาชิก</p>
      <ol>
        ① สมาชิกต้องให้ข้อมูลที่เป็นจริงแก่บริษัทตามข้อกำหนดในข้อตกลงนี้ และจะไม่ได้รับความคุ้มครองจากความเสียหายใด ๆ
        ที่เกิดขึ้นอันเนื่องมาจากการให้ข้อมูลเท็จ
        <br />
        <br />
        ② หากข้อมูลที่สมาชิกได้กรอกไว้ในขั้นตอนการสมัครสมาชิกมีการเปลี่ยนแปลง สมาชิกต้องดำเนินการแก้ไขผ่านระบบออนไลน์
        หรือแจ้งให้บริษัททราบถึงการเปลี่ยนแปลงดังกล่าวผ่านทางอีเมลหรือวิธีการอื่น ๆ
        <br />
        <br />
        ③ บริษัทจะไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นกับสมาชิกหรือบุคคลภายนอก
        เนื่องจากสมาชิกไม่แจ้งการเปลี่ยนแปลงข้อมูลให้บริษัททราบ
        <br />
      </ol>
      <p>ข้อที่ 8 หน้าที่ในการคุ้มครองข้อมูลส่วนบุคคล</p>
      บริษัทจะดำเนินการตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลและกฎหมายที่เกี่ยวข้อง เพื่อปกป้องข้อมูลส่วนบุคคลของสมาชิก
      การเก็บรวบรวม การใช้
      และการประมวลผลข้อมูลส่วนบุคคลจะเป็นไปตามกฎหมายที่เกี่ยวข้องและนโยบายการคุ้มครองข้อมูลส่วนบุคคลของบริษัท
      <br />
      ทั้งนี้ นโยบายดังกล่าวจะไม่มีผลบังคับใช้กับเว็บไซต์ภายนอกที่เชื่อมโยงจากแพลตฟอร์มของบริษัท
      ซึ่งไม่ใช่เว็บไซต์ทางการของบริษัท
      <p>ข้อที่ 9 หน้าที่ในการจัดการไอดีและรหัสผ่านของสมาชิก</p>
      <ol>
        ① สมาชิกมีหน้าที่รับผิดชอบในการจัดการ ควบคุมไอดีและรหัสผ่านของตนเอง และต้องไม่ให้บุคคลภายนอกนำไปใช้โดยเด็ดขาด
        สมาชิกต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้บัญชีของตน
        <br />
        <br />
        ② หากบริษัทเห็นว่าไอดีของสมาชิกอาจทำให้เกิดความเข้าใจผิดว่าเป็นเจ้าหน้าที่ของบริษัท มีเนื้อหาที่ไม่เหมาะสม
        ขัดต่อศีลธรรมอันดี หรือเสี่ยงต่อการรั่วไหลของข้อมูลส่วนบุคคล บริษัทสามารถระงับหรือจำกัดการใช้งานรหัสนั้นได้
        <br />
        <br />
        ③ หากสมาชิกทราบว่าไอดี หรือรหัสผ่านถูกนำไปใช้โดยไม่ได้รับอนุญาต หรือถูกบุคคลอื่นนำไปใช้โดยไม่ได้รับความยินยอม
        สมาชิกต้องแจ้งให้บริษัททราบโดยทันทีและปฏิบัติตามคำแนะนำของบริษัทอย่างเคร่งครัด
        <br />
        <br />④ ในกรณีที่สมาชิกไม่แจ้งบริษัทตามข้อกำหนด หรือแม้จะแจ้งแล้วแต่ไม่ปฏิบัติตามคำแนะนำของบริษัท
        หากเกิดความเสียหายขึ้น บริษัทจะไม่รับผิดชอบต่อความเสียหายนั้น
        <br />
        <br />⑤ หากบริษัททราบว่าสมาชิกได้กระทำการละเมิดข้อตกลงการใช้บริการหรือข้อกำหนดใด ๆ ของบริษัท
        บริษัทสามารถระงับหรือจำกัดการใช้งานบัญชีผู้ใช้นั้นได้
      </ol>
      <p>ข้อที่ 10 การแจ้งสมาชิก</p>
      <ol>
        ① บริษัทจะแจ้งข้อมูลหรือประกาศต่าง ๆ ต่อสมาชิกผ่านช่องทางต่าง ๆ เช่น อีเมล ข้อความภายในระบบบริการ
        หรือแสดงเป็นหน้าต่างป๊อปอัปขณะเข้าสู่ระบบ เว้นแต่จะมีระบุไว้เป็นการเฉพาะในข้อตกลงฉบับนี้
        <br />
        <br />② ในกรณีที่บริษัทต้องแจ้งให้สมาชิกทั้งหมดทราบ
        บริษัทต้องดำเนินการโดยการโพสต์ข้อความบนกระดานประกาศภายในบริการ หรือแสดงผ่านหน้าต่างป๊อปอัปอย่างน้อย 7 วัน
        ซึ่งถือเป็นการแจ้งอย่างเป็นทางการแทนการแจ้งเป็นรายบุคคล อย่างไรก็ตาม
        หากเป็นเรื่องที่มีผลกระทบสำคัญต่อการทำธุรกรรมของสมาชิกโดยตรง
        บริษัทจะต้องดำเนินการแจ้งให้ทราบเป็นรายบุคคลตามวิธีการในวรรคก่อนหน้า
      </ol>
      <p>ข้อที่ 11 หน้าที่ของบริษัท</p>
      <ol>
        ① บริษัทจะไม่กระทำการใด ๆ ที่ขัดต่อกฎหมายที่เกี่ยวข้อง ข้อกำหนดในการใช้บริการฉบับนี้ หรือข้อตกลงเพิ่มเติมอื่นใด
        รวมทั้งจะไม่กระทำการที่ขัดต่อศีลธรรมอันดี
        และจะมุ่งมั่นอย่างเต็มที่ในการให้บริการแก่สมาชิกอย่างต่อเนื่องและมั่นคง
        <br />
        <br />
        ② บริษัทมีหน้าที่จัดให้มีระบบรักษาความปลอดภัยเพื่อคุ้มครองข้อมูลส่วนบุคคลของสมาชิก (รวมถึงข้อมูลเครดิต)
        และต้องเปิดเผยนโยบายการคุ้มครองข้อมูลส่วนบุคคลอย่างชัดเจน รวมทั้งปฏิบัติตามนโยบายดังกล่าวโดยเคร่งครัด
        <br />
        <br />
        ③ บริษัทจะจัดเตรียมบุคลากรและระบบที่เหมาะสม
        เพื่อให้สามารถรับเรื่องร้องเรียนหรือคำขอเยียวยาความเสียหายจากการใช้บริการของสมาชิกได้อย่างมีเหมาะสม
        <br />
        <br />④ หากบริษัทพิจารณาแล้วเห็นว่าความคิดเห็นหรือข้อร้องเรียนที่สมาชิกเสนอมีความสมเหตุสมผล
        บริษัทจะดำเนินการแก้ไขตามสมควร และจะแจ้งผลการดำเนินงาน หรือความคืบหน้าให้สมาชิกทราบผ่านกระดานข้อความ
        หรือทางอีเมล
        <br />
        <br />⑤ บริษัทจะไม่รับผิดชอบต่อความเสียหาย หรือความสูญเสียใด ๆ ที่เกิดจากการกระทำโดยมิชอบของสมาชิกหรือผู้ใช้งาน
        ซึ่งรวมถึงการกระทำที่ฝ่าฝืนกฎหมาย หรือการกระทำที่ขัดต่อข้อกำหนดของบริษัท
      </ol>
      <p>ข้อที่ 12 หน้าที่ของสมาชิก</p>
      <ol>
        ① สมาชิกต้องไม่กระทำการใด ๆ ดังต่อไปนี้
        <li> ให้ข้อมูลอันเป็นเท็จขณะสมัครหรือเปลี่ยนแปลงข้อมูล</li>
        <li> ใช้ข้อมูลส่วนบุคคลของผู้อื่นโดยไม่ได้รับอนุญาต</li>
        <li> แก้ไข ดัดแปลง แปล หรือปรับใช้ข้อมูลที่บริษัทเผยแพร่</li>
        <li> ส่งหรือเผยแพร่ข้อมูลอื่นใดที่ไม่ได้รับอนุญาตจากบริษัท (เช่น โปรแกรมคอมพิวเตอร์ ฯลฯ)</li>
        <li> กระทำการย้อนรหัส ซอร์สโค้ดของคำสั่ง ซอฟต์แวร์ หรือข้อมูลประกอบบริการของบริษัท</li>
        <li> หลีกเลี่ยงหรือแทรกแซงระบบรักษาความปลอดภัยหรือข้อจำกัดในการใช้บริการของบริษัท</li>
        <li>
          เข้าถึง ทำลาย ทำให้ระบบไม่สามารถใช้งานได้ แทรกแซง หรือสร้างภาระให้กับข้อมูล ระบบ หรือเครือข่ายของบริษัท
          หรือบุคคลที่สามโดยไม่ได้รับอนุญาต
        </li>
        <li> กระทำการใด ๆ ที่อาจก่อให้เกิดความเสียหายต่อบริษัทหรือบุคคลที่สาม</li>
        <li> ละเมิดสิทธิในทรัพย์สินทางปัญญา เช่น ลิขสิทธิ์ของบริษัทหรือบุคคลที่สาม</li>
        <li> กระทำการที่ทำให้ชื่อเสียงของบริษัทหรือบุคคลที่สามเสียหาย หรือขัดขวางการดำเนินงานของบริษัท</li>
        <li>
          โพสต์หรือเปิดเผยข้อความ รูปภาพ เสียง หรือเนื้อหาอื่นใดที่ลามก รุนแรง หรือขัดต่อศีลธรรมอันดีผ่านทางบริการ
        </li>
        <li> ใช้บริการเพื่อแสวงหาผลกำไรโดยไม่ได้รับอนุญาตจากบริษัท</li>
        <li> ให้บุคคลที่สามใช้บัญชีของตนแทนตนเอง</li>
        <li> กระทำการที่ขัดต่อกฎหมายของประเทศที่บริษัทหรือสมาชิกพำนักอยู่</li>
        <li> กระทำการอื่นใดที่ผิดกฎหมายหรือไม่เหมาะสม</li>
        <br /> ② สมาชิกและผู้ใช้บริการต้องรับผิดชอบโดยตรงต่อเนื้อหาและโพสต์ทั้งหมดที่ตนสร้างขึ้น ไม่ว่าจะเป็นข้อความ
        เสียง รูปภาพ วิดีโอ หรือทรัพยากรดิจิทัลอื่น ๆ ทั้งนี้
        สมาชิกและผู้ใช้งานจะต้องรับผิดชอบอย่างเต็มที่ต่อผลลัพธ์ที่เกิดจากการใช้บริการ AI ของบริษัท
        และต้องปฏิบัติตามข้อตกลงการใช้งาน นโยบาย
        <br />
        ของบริษัท และกฎหมายที่เกี่ยวข้อง หากมีการใช้บริการในลักษณะที่ฝ่าฝืนหรือผิดกฎหมาย
        สมาชิกหรือผู้ใช้งานจะต้องรับผิดชอบต่อความเสียหายที่เกิดขึ้นทั้งหมด
        <br />
        <br /> ③ สมาชิกหรือผู้ใช้งานถือว่ายินยอมรับว่า ผลลัพธ์ที่สร้างขึ้นจากบริการ AI ของบริษัท เช่น ข้อความ เอกสาร ภาพ
        วิดีโอ เสียง ดนตรี หรือการออกแบบ เป็นผลงานที่สร้างขึ้นโดยระบบ AI
        <br />
        บริษัทไม่รับประกันความถูกต้องหรือความน่าเชื่อถือของผลลัพธ์หรือเนื้อหาที่สร้างขึ้นจากบริการ AI ดังกล่าว
        <br />
        <br /> ④ สมาชิกมีหน้าที่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง ข้อกำหนดของข้อตกลงฉบับนี้ นโยบายการดำเนินงาน
        ข้อตกลงเพิ่มเติม คำแนะนำในการใช้บริการ และประกาศต่าง ๆ จากบริษัท รวมถึงกฎหมายคุ้มครอง
        <br />
        เยาวชน สมาชิกต้องไม่กระทำการใด ๆ ที่รบกวนหรือขัดขวางการดำเนินงานของบริษัท
        หากสมาชิกหรือผู้ใช้งานฝ่าฝืนข้อกำหนดดังกล่าว บริษัทอาจระงับหรือยุติบัญชีของบุคคลนั้น
        และสามารถลบโพสต์หรือเนื้อหาที่เกี่ยวข้องออกจากระบบได้
      </ol>
      <p>ข้อที่ 13 การแสดงรายละเอียดของบริการที่มีค่าใช้จ่าย</p>
      <ol>
        ① บริษัทจะแสดงข้อมูลต่อไปนี้อย่างชัดเจนในหน้าจอเริ่มต้นของการใช้บริการแบบเสียค่าใช้จ่าย หรือในหน้าคำถามที่พบบ่อย
        (FAQ) เพื่อให้สมาชิกสามารถเข้าใจได้ง่าย
        <li>ชื่อหรือชื่อทางการค้าของบริการเสียค่าใช้จ่าย</li>
        <li>ชื่อผู้ให้บริการ (ในกรณีที่เป็นนิติบุคคล ให้ระบุชื่อบริษัท), ที่อยู่, หมายเลขโทรศัพท์</li>
        <li>รายละเอียดของบริการเสียค่าใช้จ่าย, วิธีการใช้งาน, ค่าบริการ, และเงื่อนไขการใช้งานอื่น ๆ</li>
        <br />
        ② อุปกรณ์ที่สามารถใช้งานบริการแบบเสียค่าใช้จ่าย และข้อกำหนดทางเทคนิคขั้นต่ำที่จำเป็นต่อการใช้งาน
        จะเป็นไปตามข้อมูลจำเพาะที่บริษัทแนะนำ
        <br />
        <br />
        ③ บริษัทจะให้ข้อมูลเกี่ยวกับเงื่อนไขและขั้นตอนของการเปลี่ยนสินค้า การคืนเงิน
        และการรับประกันที่เกี่ยวข้องกับบริการเสียค่าใช้จ่าย โดยอ้างอิงตามข้อกำหนดที่ระบุไว้ในข้อที่ 19 ของข้อตกลงนี้
        <br />
        <br />④ บัตรบริการ หรือคูปองใช้งานบริการที่บริษัทจัดจำหน่าย อาจมีการจัดจำหน่ายผ่านบุคคลภายนอก
        (รวมถึงบริษัทในเครือของบริษัท) โดยวิธีการใช้งาน เงื่อนไขการยกเลิกคำสั่งซื้อ
        และการขอคืนเงินจะเป็นไปตามข้อตกลงการใช้บริการและนโยบายของแต่ละบริษัทพันธมิตรที่เกี่ยวข้อง
      </ol>
      <p>ข้อที่ 14 การให้บริการ การระงับ และการเปลี่ยนแปลงบริการ</p>
      <ol>
        ① บริษัทอาจแบ่งการให้บริการออกเป็นช่วงเวลาต่าง ๆ และสามารถกำหนดเวลาการให้บริการแยกเป็นรายช่วงได้ตามความเหมาะสม
        ในกรณีดังกล่าว บริษัทจะแจ้งรายละเอียดให้สมาชิกทราบล่วงหน้า
        <br />
        <br />
        ② บริการจะเปิดให้ใช้งานตลอด 24 ชั่วโมง ทุกวัน ไม่เว้นวันหยุด
        <br />
        <br />
        ③ บริษัทอาจระงับการให้บริการชั่วคราวในกรณีที่ต้องดำเนินการตรวจสอบ ซ่อมบำรุง
        หรือเปลี่ยนแปลงอุปกรณ์เทคโนโลยีสารสนเทศ เช่น คอมพิวเตอร์ หรือหากเกิดเหตุขัดข้องของระบบการสื่อสาร หรือมี
        <br />
        เหตุผลอันสมควรด้านการดำเนินงาน โดยในกรณีดังกล่าว บริษัทจะแจ้งให้สมาชิกทราบล่วงหน้าตามวิธีที่ระบุไว้ในข้อตกลงนี้
        เว้นแต่จะเกิดเหตุสุดวิสัยที่ไม่สามารถแจ้งล่วงหน้าได้ ซึ่งในกรณีนี้ บริษัทอาจแจ้งภายหลังได้
        <br />
        <br />
        ④ บริษัทสามารถกำหนดระยะเวลาตรวจสอบระบบเป็นประจำตามความจำเป็น และจะแจ้งให้ทราบล่วงหน้าผ่านทางหน้าจอของบริการ
        <br />
        <br />
        ⑤ ในกรณีที่บริษัทไม่สามารถให้บริการแบบเสียค่าใช้จ่ายได้อีกต่อไป อันเนื่องมาจากการเปลี่ยนประเภทธุรกิจ
        การเลิกดำเนินกิจการ การแยก หรือการควบรวมกิจการ บริษัทจะแจ้งให้สมาชิกทราบตามวิธีที่กำหนดไว้ในข้อตกลง
        และดำเนินการชดเชยให้สมาชิกตามเงื่อนไขที่ได้ตกลงกันไว้
        <br />
        <br />⑥ บริษัทสามารถเปลี่ยนแปลงบริการทั้งหมดหรือบางส่วนได้ตามเหตุผลอันสมควรทั้งด้านการดำเนินงานหรือด้านเทคนิค
        โดยจะแจ้งรายละเอียดผ่านหน้าจอเริ่มต้นของบริการ ทั้งนี้ หากการเปลี่ยนแปลงดังกล่าวส่งผลเสียต่อสมาชิก
        บริษัทจะดำเนินการแจ้งให้ทราบล่วงหน้าตามที่ระบุไว้ในข้อตกลง และหากจำเป็น
        บริษัทจะดำเนินการชดเชยสมาชิกตามข้อกำหนดของข้อตกลงนี้
      </ol>
      <p>ข้อที่ 15 การให้ข้อมูลและการแสดงโฆษณา</p>
      <ol>
        ① บริษัทอาจให้ข้อมูลที่บริษัทเห็นว่าจำเป็นต่อการใช้บริการแก่สมาชิกผ่านทางประกาศ, อีเมล หรือวิธีการอื่น
        อย่างไรก็ตาม สมาชิกสามารถปฏิเสธการรับอีเมลได้ตลอดเวลา
        ยกเว้นในกรณีของข้อมูลที่เกี่ยวข้องกับธุรกรรมหรือการตอบคำถามจากลูกค้า ซึ่งจำเป็นต้องส่งตามที่กฎหมายกำหนด <br />
        <br />② ในกรณีที่บริษัทส่งข้อมูลผ่านช่องทางอิเล็กทรอนิกส์ จะต้องได้รับความยินยอมล่วงหน้าจากสมาชิกก่อน
        ยกเว้นในกรณีของข้อมูลที่เกี่ยวข้องกับธุรกรรมหรือการตอบคำถามจากลูกค้า
        ซึ่งสามารถส่งได้โดยไม่ต้องขอความยินยอมล่วงหน้า
        <br />
        <br />③ หากผู้ใช้สมัครรับข้อมูลข่าวสารหรือการแจ้งเตือนเกี่ยวกับการอัปเดตบริการ
        บริษัทสามารถส่งข้อมูลดังกล่าวผ่านอีเมล ข้อความ (SMS) การแจ้งเตือนผ่านแอปพลิเคชัน (App Push)
        หรือข้อความอิเล็กทรอนิกส์อื่น ๆ
        <br />
        <br /> ④ เนื้อหาของการแจ้งเตือนอัปเดตอาจมีการเปลี่ยนแปลง ลบ หรือเพิ่มเติมตามนโยบายการให้บริการของบริษัท
        <br />
        <br />
        ⑤ ผู้ใช้สามารถปิดการรับการแจ้งเตือนอัปเดตได้ทุกเมื่อผ่านการตั้งค่า ซึ่งเมื่อผู้ใช้ปิดการรับ
        บริษัทจะไม่ส่งการแจ้งเตือนดังกล่าวอีก
        <br />
        <br />
        ⑥ บริษัทสามารถแสดงโฆษณาโดยตรงบนหน้าจอของบริการ เว็บไซต์หลัก หรือผ่านบุคคลภายนอก เช่น บริษัท บับเบิ้ลแท็ป จำกัด
        หรือพันธมิตรทางธุรกิจอื่น ๆ
        <br />
        <br />
        ⑦ บริษัทจะส่งข้อมูลโฆษณาผ่านช่องทางอิเล็กทรอนิกส์ เช่น อีเมล ข้อความ การแจ้งเตือนแอป
        หรือข้อความอิเล็กทรอนิกส์อื่น ๆ ให้แก่สมาชิกได้เฉพาะในกรณีที่สมาชิกได้ให้ความยินยอมล่วงหน้า
        สมาชิกสามารถปฏิเสธการรับข้อมูลโฆษณาได้ตลอดเวลา และบริษัทจะไม่ส่งข้อมูลโฆษณาหากสมาชิกได้ปฏิเสธ
        <br />
        <br />⑧ สมาชิกจะไม่ดำเนินการใด ๆ ที่เปลี่ยนแปลง แก้ไข หรือจำกัดโพสต์หรือข้อมูลที่บริษัทให้ไว้ในบริการ
      </ol>
      <p>ข้อที่ 16 ลิขสิทธิ์ของโพสต์</p>
      <ol>
        ① ลิขสิทธิ์ของโพสต์ที่สมาชิกโพสต์ในบริการจะเป็นของเจ้าของโพสต์นั้น
        สมาชิกให้สิทธิ์ในการใช้งานหรือให้ใบอนุญาตแก่บริษัทตามข้อตกลงนี้ การให้สิทธิดังกล่าวไม่ใช่การโอนลิขสิทธิ์
        และไม่รวมถึงเครื่องมือ เทคโนโลยี ซอฟต์แวร์ การออกแบบแพลตฟอร์ม หรือข้อความที่บริษัทให้แก่สมาชิกเพื่อสร้างโพสต์
        สมาชิกไม่สามารถทำซ้ำ ดัดแปลง แจกจ่าย หรือใช้ทรัพย์สินทางปัญญาของบริษัทโดยไม่ได้รับอนุญาตจากบริษัท
        <br />
        <br />
        ② เมื่อผู้ใช้นำโพสต์ของตนเผยแพร่บนแพลตฟอร์มของบริษัท จะถือว่าให้สิทธิ์การใช้งานแบบไม่จำกัดและไม่ผูกขาดแก่บริษัท
        สิทธินี้สามารถโอนหรือให้สิทธิ์ช่วงแก่บุคคลภายนอกได้ และสามารถนำไปใช้ในเชิงพาณิชย์ เช่น การสร้างงานต่อยอด วิจัย
        พัฒนาแบบจำลอง AI การตลาด และการโปรโมตบริการผ่านช่องทางต่าง ๆ ในสื่อใหม่ หรือภาษาอื่น ๆ ทั้งนี้ อาจมีการปรับแต่ง
        ทำซ้ำ หรือจัดรูปแบบใหม่ตามความจำเป็น โพสต์เหล่านี้อาจถูกนำไปใช้เพื่อการวิจัยและพัฒนาเพื่อปรับปรุงบริการ
        <br />
        <br />
        ③ ผู้ใช้หรือสมาชิกมีสิทธิในลิขสิทธิ์ของเนื้อหาที่สร้างขึ้นโดยบริการ AI ของบริษัท (เช่น ข้อความผลลัพธ์,
        ข้อความทั่วไป, ภาพ, เสียง, เพลง, เพลงประกอบ, วิดีโอ ฯลฯ) ตามที่กฎหมายของแต่ละประเทศกำหนด ทั้งนี้
        การที่ผู้ใช้หรือสมาชิกใช้บริการของบริษัท
        ถือว่าเป็นการอนุญาตให้บริษัทใช้สิทธิ์ในการใช้งานเนื้อหาดังกล่าวในลักษณะที่ไม่ผูกขาดและมีข้อจำกัด
        สิทธิ์ในการใช้งานนี้สามารถถ่ายโอนหรือให้สิทธิ์ช่วงต่อแก่บุคคลภายนอกได้โดยไม่จำกัด
        และสามารถนำไปใช้ในวัตถุประสงค์เชิงพาณิชย์ได้หลากหลายรูปแบบ เช่น การสร้างงานดัดแปลง การวิจัยและพัฒนาแบบจำลอง
        หรือการฝึกระบบปัญญาประดิษฐ์ (AI) เนื้อหาที่ผู้ใช้หรือสมาชิกสร้างขึ้นผ่านการใช้บริการของบริษัท
        อาจถูกนำไปใช้ในการประชาสัมพันธ์ การโฆษณา การโปรโมต การขยายบริการของบริษัทในปัจจุบันและอนาคต
        รวมถึงการเผยแพร่ผ่านสื่อหรือภาษาใหม่ โดยอาจมีการปรับแก้ แก้ไข ทำซ้ำ
        หรือดัดแปลงตามความจำเป็นในขอบเขตที่เกี่ยวข้องกับการใช้งานดังกล่าว นอกจากนี้
        เนื้อหาที่ผู้ใช้หรือสมาชิกสร้างขึ้นยังอาจถูกนำมาใช้เพื่อการปรับปรุงบริการของบริษัท การพัฒนาคอนเทนต์ใหม่
        ตลอดจนเพื่อวัตถุประสงค์ในการวิจัยและพัฒนาทางเทคโนโลยี
        <br />
        <br />④ แม้ว่าผู้ใช้จะลบหรือตั้งค่าการมองเห็นโพสต์ของตนให้เป็นส่วนตัวบนบริการของบริษัท
        สิทธิ์การใช้งานที่มอบให้บริษัทตามวรรคที่ 2 จะยังคงมีผลต่อไป
        <br />
        <br />⑤ หากบริษัทต้องการใช้โพสต์ของสมาชิกนอกเหนือจากขอบเขตในวรรค 2
        จะต้องได้รับความยินยอมจากสมาชิกล่วงหน้าผ่านทางโทรศัพท์ แฟกซ์ หรืออีเมล
        <br />
        <br />⑥ สมาชิกต้องรับรองต่อบริษัทว่าตนมีสิทธิ์โดยชอบธรรมในการเป็นเจ้าของ หรือได้รับสิทธิ์ในเนื้อหา ข้อความ
        หรือโพสต์ทั้งหมดที่เผยแพร่หรือป้อนเข้าสู่บริการของบริษัท
      </ol>
      <p>ข้อที่ 17 การจัดการเนื้อหาที่เผยแพร่โดยสมาชิก</p>
      <ol>
        ① หากเนื้อหาที่สมาชิกเผยแพร่บนแพลตฟอร์มของบริษัทมีเนื้อหาละเมิดต่อกฎหมายที่เกี่ยวข้อง เช่น
        พระราชบัญญัติส่งเสริมการใช้เครือข่ายข้อมูลและการคุ้มครองข้อมูล หรือกฎหมายลิขสิทธิ์
        เจ้าของสิทธิ์สามารถร้องขอให้ระงับหรือลบเนื้อหาดังกล่าวได้ตามขั้นตอนที่กฎหมายกำหนด
        บริษัทจะต้องดำเนินการตามที่กฎหมายกำหนด
        <br />
        <br />
        ② แม้จะไม่มีคำร้องขอจากเจ้าของสิทธิ์ หากมีเหตุอันควรสงสัยว่าเนื้อหานั้นละเมิดสิทธิ์ของผู้อื่น
        หรือขัดต่อนโยบายของบริษัทและกฎหมายที่เกี่ยวข้อง
        บริษัทสามารถดำเนินการระงับเนื้อหานั้นชั่วคราวหรือถาวรตามที่กฎหมายกำหนดได้ บริษัทจึงมีสิทธิ์ในการตรวจสอบ ลบ
        หรือระงับเนื้อหาที่สมาชิกหรือผู้ใช้เผยแพร่ และอาจระงับหรือยกเลิกบัญชีของผู้ใช้นั้นตามดุลยพินิจของบริษัท
        <br />
        <br />③ ขั้นตอนโดยละเอียดเกี่ยวกับการจัดการเนื้อหาตามข้อกำหนดนี้
        จะเป็นไปตามระบบร้องขอระงับการเผยแพร่ของบริษัทภายใต้ขอบเขตที่กฎหมาย เช่น
        พระราชบัญญัติส่งเสริมการใช้เครือข่ายข้อมูลและการคุ้มครองข้อมูล และกฎหมายลิขสิทธิ์ กำหนดไว้
      </ol>
      <p>ข้อที่ 18 การเป็นเจ้าของสิทธิ์</p>
      <ol>
        ① ลิขสิทธิ์และทรัพย์สินทางปัญญาทั้งหมดที่เกี่ยวข้องกับบริการของบริษัท เป็นกรรมสิทธิ์ของบริษัท
        เว้นแต่จะเป็นเนื้อหาที่สมาชิกสร้างขึ้น หรือเนื้อหาที่ได้รับภายใต้สัญญาความร่วมมือกับบุคคลภายนอก
        <br />
        <br />② บริษัทให้สิทธิ์แก่สมาชิกในการใช้งานบัญชี ผู้ใช้งาน ข้อมูล
        และวิธีการชำระเงินตามเงื่อนไขที่บริษัทกำหนดเท่านั้น สมาชิกไม่มีสิทธิ์โอน ขาย
        หรือใช้สิ่งเหล่านี้เป็นหลักประกันในทางใดทางหนึ่ง เว้นแต่จะได้รับอนุญาตจากบริษัทเป็นลายลักษณ์อักษร
      </ol>
      <p>ข้อที่ 19 วิธีการชำระเงินและการคืนเงิน</p>
      ① สมาชิกสามารถเลือกใช้วิธีการชำระเงินสำหรับบริการที่มีค่าใช้จ่ายตามช่องทางที่บริษัทกำหนด
      โดยบางบริการอาจรองรับวิธีการชำระเงินเพียงบางประเภทเท่านั้น
      ขึ้นอยู่กับการดำเนินการของบริษัทหรือข้อตกลงกับผู้ให้บริการคอนเทนต์ หากผู้ให้บริการช่องทางชำระเงินมีเงื่อนไขเฉพาะ
      สมาชิกต้องปฏิบัติตามขั้นตอนของผู้ให้บริการนั้นก่อนจึงจะสามารถใช้งานได้
      โดยสัญญาระหว่างสมาชิกกับผู้ให้บริการชำระเงินจะมีผลบังคับใช้ในส่วนดังกล่าว
      <br />
      <br />
      วิธีการชำระเงินที่รองรับ ได้แก่:
      <br />
      <ol>
        <li> การชำระเงินในแอปผ่าน Google Play</li>
        <li> การชำระเงินในแอปผ่าน App Store</li>
        <li> การชำระเงินผ่านเว็บไซต์ของ Toss Payments Co., Ltd.</li>
        <li> วิธีการชำระเงินอื่น ๆ ที่บริษัทกำหนด</li>
        <br />② ตามนโยบายของบริษัท หรือข้อกำหนดของผู้ให้บริการชำระเงิน สมาชิกอาจถูกจำกัดยอดการชำระเงินรายเดือน
        หรือจำนวนการซื้อบริการแบบชำระเงิน หากเกินวงเงินที่กำหนด สมาชิกจะไม่สามารถใช้บริการเพิ่มเติมได้
        ในกรณีที่ใช้บัตรเครดิตซื้อสกุลเงินภายในระบบ
        อาจเกิดการจำกัดวงเงินหรือไม่สามารถชำระเงินได้ตามที่บริษัทบัตรเครดิตกำหนด
        <br />
        <br />③ สกุลเงินภายในระบบของบริษัทไม่สามารถโอนย้ายให้สมาชิกคนอื่นได้
        <br />
        <br />④ ระยะเวลาที่สามารถใช้สกุลเงินภายในระบบของบริษัทมีดังนี้:
        <ol>
          <li> สกุลเงินที่ซื้อด้วยเงินจริง: ใช้ได้ภายใน 1 ปี</li>
          <li> สกุลเงินที่ได้รับฟรี: ใช้ได้ไม่เกิน 1 ปีเช่นกัน</li>
        </ol>
        ⑤ การยกเลิกการชำระเงิน และการขอคืนเงิน
        <ol>
          <li> การคืนเงินจะดำเนินการผ่านช่องทางการชำระเงินที่ใช้ในการซื้อ</li>
          <li> สมาชิกสามารถร้องขอคืนเงินได้ภายใน 7 วันนับจากวันที่ซื้อสกุลเงินภายในระบบ </li>
          <li>
            เงื่อนไขการคืนเงินมีดังนี้
            <ol>
              <li style={{ listStyleType: 'lower-roman' }}>
                หากสมาชิกได้ใช้สกุลเงินภายในระบบ (ทั้งที่ได้มาจากการซื้อหรือได้รับฟรี) ไปแล้วบางส่วน
                จะไม่สามารถขอยกเลิกหรือคืนเงินสำหรับส่วนที่เหลือได้ กล่าวคือ ไม่สามารถขอคืนเงินแบบบางส่วนได้
              </li>
              <li style={{ listStyleType: 'lower-roman' }}>
                หากยังไม่ได้ใช้สกุลเงินภายในระบบที่ซื้อมาเลย (รวมทั้งส่วนที่ได้ฟรี)
                จะสามารถขอยกเลิกและคืนเงินเต็มจำนวนตามราคาที่ชำระ
              </li>
            </ol>
          </li>
          <li>
            หากเกิดความผิดพลาดจากระบบชำระเงินอันเนื่องมาจากความผิดของบริษัท สมาชิกสามารถขอยกเลิกหรือขอคืนเงินได้
            (อ้างอิงใน ข้อที่ 23 ของข้อกำหนดและเงื่อนไขนี้)
          </li>
          <li>
            หากบริการถูกระงับเนื่องจากความผิดของบริษัท สมาชิกสามารถขอยกเลิกและคืนเงินได้ (อ้างอิงใน ข้อที่ 14
            ของข้อกำหนดและเงื่อนไขนี้)
          </li>
        </ol>
      </ol>
      <p>ข้อที่ 20 การเพิกถอนคำสั่งซื้อ การยกเลิกสัญญา และการยกเลิกการเป็นสมาชิก</p>
      <ol>
        ① สมาชิกสามารถยื่นคำขอเลิกสัญญาการใช้บริการหรือยกเลิกการเป็นสมาชิกได้ตลอดเวลา
        ผ่านเมนูศูนย์บริการลูกค้าหรือเมนูจัดการข้อมูลส่วนตัวในหน้าหลักของบริการ
        โดยบริษัทจะต้องดำเนินการตามคำร้องดังกล่าวทันทีตามที่กฎหมายที่เกี่ยวข้องกำหนด
        <br />
        <br />
        ② หากสมาชิกยกเลิกสัญญาหรือยกเลิกการเป็นสมาชิก บริษัทจะลบข้อมูลของสมาชิกทั้งหมดทันที
        เว้นแต่ในกรณีที่จำเป็นต้องเก็บรักษาไว้ตามกฎหมายที่เกี่ยวข้องหรือ นโยบายความเป็นส่วนตัว
        <br />
        <br />
        ③ เมื่อสมาชิกยกเลิกสัญญาหรือยกเลิกการเป็นสมาชิก เนื้อหาที่สมาชิกได้เผยแพร่ไว้ เช่น โพสต์ หรือคอนเทนต์ต่าง ๆ
        ที่ยังอยู่ในบัญชีอาจไม่ถูกลบโดยอัตโนมัติ โดยเฉพาะอย่างยิ่งเนื้อหาที่สมาชิกได้สร้างขึ้น เช่น ตัวละคร AI
        โครงเรื่อง หรือธีมต่าง ๆ จะไม่ถูกลบ นอกจากนี้ หากเนื้อหาดังกล่าวถูกนำไปแชร์หรือเก็บไว้โดยบุคคลอื่น
        หรือโพสต์ไว้ในบอร์ดสาธารณะ เนื้อหานั้นก็จะไม่ถูกลบเช่นกัน ดังนั้น
        สมาชิกควรลบเนื้อหาที่ต้องการก่อนดำเนินการยกเลิกการเป็นสมาชิก
        <br />
        <br />④ สมาชิกที่ทำสัญญาการใช้บริการแบบมีค่าใช้จ่ายหรือซื้อสกุลเงินภายในระบบของบริษัท
        อาจใช้สิทธิ์ในการเพิกถอนคำสั่งซื้อหรือยกเลิกสัญญาภายในระยะเวลาที่กฎหมายหรือบริษัทกำหนดไว้ อย่างไรก็ตาม
        การเพิกถอนหรือยกเลิกอาจไม่สามารถทำได้ในกรณีดังต่อไปนี้
        <ol>
          <li>
            บริษัทเห็นว่าสมาชิกใช้สิทธิ์คืนเงินจากการซื้อสกุลเงินภายในระบบโดยมีเจตนาแสวงหาผลประโยชน์ในทางที่ไม่เหมาะสม
            (ตามที่ระบุไว้ในนโยบายการให้บริการ ข้อที่ 6)
          </li>
          <li>
            สมาชิกได้ใช้สกุลเงินภายในระบบบางส่วน ไม่ว่าจะเป็นส่วนที่ซื้อหรือได้รับฟรี
            แล้วจึงร้องขอคืนเงินสำหรับสกุลเงินที่เหลือ
          </li>
          <li>สมาชิกขอคืนเงินสำหรับสกุลเงินภายในระบบที่ได้รับฟรีจากบริษัท</li>
          <li>ความเสียหาย หรือการสูญหายของสินค้าหรือบริการอันเกิดจากความผิดของสมาชิกเอง</li>
          <li> มูลค่าของบริการลดลง เนื่องจากการใช้หรือบริโภคบางส่วน</li>
          <li> บริการมีมูลค่าลดลงอย่างมากเนื่องจากเวลาผ่านไปจนไม่สามารถจำหน่ายใหม่ได้</li>
          <li>
            บริการที่สามารถคัดลอกได้ถูกเปิดใช้งานแล้ว เช่น
            ดิจิทัลคอนเทนต์ตามกฎหมายว่าด้วยการส่งเสริมอุตสาหกรรมวัฒนธรรมพื้นฐาน มาตรา 2 ข้อ 5
            ยกเว้นในกรณีที่เป็นบริการบางส่วนที่ยังไม่ถูกใช้งาน
          </li>
          <li>
            บริการที่ผลิตตามคำสั่งเฉพาะของสมาชิก และการคืนเงินอาจก่อให้เกิดความเสียหายอย่างร้ายแรงแก่บริษัท
            ซึ่งบริษัทได้แจ้งรายละเอียดและได้รับความยินยอมเป็นลายลักษณ์อักษร (รวมถึงเอกสารอิเล็กทรอนิกส์) ล่วงหน้าแล้ว
          </li>
        </ol>
        ⑤ หากบริการแบบมีค่าใช้จ่ายที่สมาชิกได้รับไม่ตรงกับที่โฆษณาหรือไม่เป็นไปตามข้อตกลง
        สมาชิกสามารถขอเพิกถอนคำสั่งซื้อหรือยกเลิกสัญญาได้ภายใน 3 เดือนนับจากวันที่ได้รับบริการ หรือภายใน 30
        วันนับจากวันที่ทราบ
        <br />
        <br />⑥ สมาชิกสามารถยกเลิกสัญญาการใช้บริการแบบมีค่าใช้จ่ายได้ในกรณีต่อไปนี้:
        <ol>
          <li>
            บริการแบบมีค่าใช้จ่ายมีข้อบกพร่องที่ไม่สามารถแก้ไขหรือปรับปรุงได้ ภายใน 1 เดือนนับจากวันที่ได้รับบริการ
          </li>
          <li>
            สมาชิกไม่ยินยอมต่อการเปลี่ยนแปลงในข้อกำหนดและเงื่อนไข
            และประสงค์จะยกเลิกการเป็นสมาชิกหรือยกเลิกการใช้บริการแบบมีค่าใช้จ่าย
          </li>
        </ol>
        ⑦ ข้อกำหนดเกี่ยวกับการคืนสินค้า การเปลี่ยนสินค้า การคืนเงิน และการยกเลิกตามข้อ 1 และข้อ 2
        จะดำเนินการตามที่ระบุไว้ในข้อที่ 21
      </ol>
      <p>ข้อที่ 21 ผลของการเพิกถอนคำสั่งซื้อ และการยกเลิกสัญญา</p>
      <ol>
        ① บริษัทต้องแจ้งให้สมาชิกทราบถึงผลการคืนเงินภายใน 3
        วันทำการนับจากวันที่สมาชิกแสดงเจตนาขอเพิกถอนคำเสนอซื้อหรือยกเลิกสัญญา และจะต้องดำเนินการคืนเงินภายใน 3
        วันทำการหลังจากแจ้งผล โดยใช้วิธีเดียวกับที่สมาชิกใช้ในการชำระเงิน หากไม่สามารถคืนเงินด้วยวิธีเดิมได้
        บริษัทต้องแจ้งให้สมาชิกทราบล่วงหน้า ทั้งนี้ หากเป็นวิธีชำระเงินที่ต้องมีการยืนยันการรับเงินก่อน
        บริษัทสามารถนับระยะเวลาคืนเงินจากวันที่ยืนยันการรับเงิน
        <br /> <br />
        ② การขอเพิกถอนคำเสนอซื้อและการยกเลิกสัญญาโดยสมาชิกอาจถูกจำกัดตามที่กำหนดไว้ในข้อ 19 และข้อ 20
        ของข้อกำหนดและเงื่อนไขนี้
        <br /> <br />
        ③ หากบริษัททำการคืนเงิน และสมาชิกได้ชำระค่าบริการผ่านบัตรเครดิตหรือช่องทางการชำระเงินอิเล็กทรอนิกส์
        บริษัทจะต้องรีบดำเนินการขอให้ผู้ให้บริการชำระเงินนั้นระงับหรือยกเลิกการเรียกเก็บเงิน ยกเว้นในกรณีตามข้อที่ 1
        และข้อที่ 2 ที่อาจไม่สามารถดำเนินการได้
        <br /> <br />
        ④ หากผู้ที่รับชำระเงินค่าบริการ และผู้ที่ทำสัญญาใช้บริการแบบเสียค่าบริการกับสมาชิกไม่ใช่บุคคลเดียวกัน
        ทั้งสองฝ่ายมีหน้าที่รับผิดชอบร่วมกันในการดำเนินการตามข้อเรียกร้องเกี่ยวกับการเพิกถอนคำเสนอซื้อ
        <br /> <br />⑤ สำหรับการชำระเงินผ่านแอป (In-App Payment) หรือการชำระเงินผ่านเว็บไซต์
        บริษัทจะดำเนินมาตรการตามกฎหมายว่าด้วยการคุ้มครองผู้บริโภคในการทำธุรกรรมอิเล็กทรอนิกส์ เช่น
        การขอระงับหรือยกเลิกการชำระเงินจากผู้ให้บริการแอป หรือระบบการชำระเงินบนเว็บไซต์ อย่างไรก็ตาม
        ผลของการดำเนินการดังกล่าวอาจขึ้นอยู่กับนโยบายของผู้ให้บริการแต่ละราย
        สมาชิกควรศึกษานโยบายของแอปหรือผู้ให้บริการที่เกี่ยวข้องล่วงหน้า
      </ol>
      <p>ข้อที่ 22 การยกเลิก ยุติสัญญา และการจำกัดการใช้งานโดยบริษัท</p>
      <ol>
        ① หากบริษัทพบว่าสมาชิกละเมิดข้อกำหนดและเงื่อนไขฉบับนี้ หรือข้อกำหนดเพิ่มเติมอื่น ๆ
        หรือมีเหตุอันควรสงสัยอย่างมีเหตุผลว่าการกระทำของสมาชิกรบกวนการให้บริการ
        บริษัทอาจดำเนินการจำกัดการใช้งานเป็นลำดับขั้น เช่น การแจ้งเตือน การระงับการใช้งานชั่วคราว
        หรือการระงับการใช้งานถาวร หากแม้จะมีการจำกัดการใช้งานแล้ว ก็ยังไม่สามารถรักษาสัญญาการใช้บริการไว้ได้
        บริษัทอาจจำเป็นต้องยกเลิกหรือยุติสัญญาการให้บริการกับสมาชิกเพิ่มเติม
        <br /> <br />
        ② หากสมาชิกไม่ได้เข้าสู่ระบบติดต่อกันเป็นระยะเวลา 3 เดือนขึ้นไป
        บริษัทสามารถจำกัดการใช้งานของสมาชิกได้โดยตรงเพื่อป้องกันข้อมูลส่วนบุคคลของสมาชิกและเพิ่มประสิทธิภาพการดำเนินงาน
        <br /> <br />
        ③ สิทธิประโยชน์ที่สมาชิกได้รับโดยไม่เสียค่าใช้จ่ายจะสิ้นสุดลงในกรณีที่ถูกจำกัดการใช้งานตามข้อ 1 และ 2
        และบริษัทไม่มีภาระผูกพันใด ๆ ในการชดเชยสิทธิประโยชน์ดังกล่าว อย่างไรก็ตาม หากการเลิกสัญญาเกิดจากความผิดของสมาชิก
        บริษัทสามารถคืนเงินค่าบริการแบบมีค่าใช้จ่ายตามคำขอของสมาชิก
        แต่จะไม่มีการคืนเงินหรือชดเชยในกรณีที่บัญชีผู้ใช้ถูกขโมยหรือถูกใช้ในกิจกรรมผิดกฎหมาย เช่น การละเมิดลิขสิทธิ์
        <br /> <br />
        ④ หากต้องมีการคืนเงินตามข้อยกเว้นในข้อที่ 3 บริษัทจะดำเนินการตามวิธีการที่กำหนดไว้ในข้อที่ 22 วรรค 1
        และหักผลประโยชน์ที่สมาชิกได้รับจากการใช้บริการแบบมีค่าใช้จ่าย รวมถึงค่าธรรมเนียมการคืนเงิน (10% หรือ 1,000 วอน
        แล้วแต่จำนวนใดมากกว่า)
        <br /> <br />
        ⑤ การยกเลิกหรือยุติสัญญาตามข้อ 1
        จะมีผลทันทีเมื่อบริษัทแสดงเจตจำนงต่อสมาชิกตามวิธีการแจ้งที่กำหนดไว้ในข้อกำหนดและเงื่อนไขฉบับนี้
        <br /> <br />⑥ สมาชิกสามารถยื่นคำร้องคัดค้านการยกเลิก เลิกสัญญา หรือการจำกัดการใช้งานได้ตามขั้นตอนที่บริษัทกำหนด
        และหากคำร้องนั้นสมเหตุสมผล บริษัทจะคืนสิทธิการใช้บริการให้แก่สมาชิกทันที
      </ol>
      <p>ข้อที่ 23 การคืนเงินกรณีเรียกเก็บเงินเกินจำนวน</p>
      <ol>
        ① หากเกิดการชำระเงินเกิน บริษัทจะคืนเงินโดยใช้วิธีการเดียวกับที่สมาชิกใช้ชำระเงิน
        หากไม่สามารถคืนเงินด้วยวิธีการเดียวกันได้ บริษัทจะแจ้งให้ทราบล่วงหน้า
        <br /> <br />
        ② หากการชำระเงินเกินเกิดขึ้นเนื่องจากความรับผิดของบริษัท บริษัทจะคืนเงินเต็มจำนวนให้สมาชิก
        แต่หากเกิดจากความผิดพลาดของสมาชิกเอง
        สมาชิกจะต้องรับผิดชอบค่าธรรมเนียมที่จำเป็นสำหรับการคืนเงินในขอบเขตที่เหมาะสม
        <br /> <br />③ ขั้นตอนการคืนเงินจากการเรียกเก็บเงินเกินจะเป็นไปตามแนวทางการคุ้มครองผู้ใช้บริการคอนเทนต์ดิจิทัล
      </ol>
      <p>ข้อที่ 24 ระยะเวลาในการใช้บริการแบบชำระเงิน</p>
      หากไม่มีการระบุระยะเวลาใช้งานหรือวันหมดอายุของบริการแบบชำระเงินไว้ล่วงหน้า ระยะเวลาใช้งานจะอยู่ที่ 1
      ปีนับจากวันที่ทำรายการซื้อ เมื่อพ้นระยะเวลาดังกล่าว สิทธิ์ในการใช้งานจะสิ้นสุดลง
      และรายการนั้นอาจถูกลบออกจากบัญชีของสมาชิก
      <p>ข้อที่ 25 การชดเชยความเสียหายจากข้อบกพร่องของบริการ</p>
      การชดเชยความเสียหายที่เกิดขึ้นกับสมาชิกเนื่องจากข้อบกพร่องของบริการแบบชำระเงิน
      จะดำเนินการตามที่ระบุไว้ในแนวทางการคุ้มครองผู้ใช้บริการเนื้อหาดิจิทัล
      <p>ข้อที่ 26 ข้อจำกัดความรับผิดชอบ</p>
      <ol>
        ① บริษัทไม่ต้องรับผิดชอบในกรณีที่ไม่สามารถให้บริการได้เนื่องจากเหตุสุดวิสัย เช่น ภัยธรรมชาติ
        หรือเหตุการณ์อื่นที่มีลักษณะเดียวกัน
        <br /> <br />
        ② บริษัทไม่ต้องรับผิดชอบต่อปัญหาหรือความเสียหายที่เกิดจากความผิดของสมาชิกเองในการใช้บริการ
        <br /> <br />
        ③ บริษัทไม่รับประกันความถูกต้อง ความน่าเชื่อถือ ความถูกต้องตามกฎหมาย ความเป็นต้นฉบับ ความเป็นเอกสิทธิ์ ความจริง
        ความสามารถในการนำไปใช้ หรือความเหมาะสมของข้อมูล เอกสาร หรือผลลัพธ์ที่สมาชิกโพสต์ผ่านบริการ หรือนำมาจากบริการ AI
        ของบริษัท และไม่รับผิดชอบต่อการกระทำของสมาชิกหรือผู้ใช้งานอันเกิดจากข้อมูลเหล่านั้น
        <br /> <br />
        ④ สมาชิกต้องรับผิดชอบต่อปัญหาหรือความเสียหายทั้งหมดที่เกิดจากการใช้ข้อมูล เอกสาร หรือผลลัพธ์จากบริการ AI
        ของบริษัท โดยบริษัทจะไม่รับผิดชอบใด ๆ ในกรณีดังกล่าว
        <br />
        <br />
        ⑤ บริษัทไม่มีหน้าที่รับผิดใด ๆ ต่อความถูกต้องหรือความน่าเชื่อถือของข้อมูล เอกสาร
        หรือเนื้อหาที่สมาชิกหรือผู้ใช้งานโพสต์ลงในกระดานข้อความหรือเผยแพร่ผ่านบริการ
        สมาชิกต้องใช้บริการภายใต้ความรับผิดชอบของตนเอง
        <br />
        <br />
        ⑥ บริษัทไม่ต้องรับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นกับสมาชิกซึ่งเป็นผลมาจากการกระทำโดยเจตนา
        หรือความประมาทเลินเล่อของสมาชิกเอง รวมถึงความเสียหายทางจิตใจที่เกิดจากการกระทำของสมาชิกคนอื่น
        <br />
        <br />
        ⑦ บริษัทไม่รับผิดชอบต่อความเสียหายหรือการสูญเสียใด ๆ ที่เกิดขึ้นจากการสื่อสาร ติดต่อ ความสัมพันธ์
        หรือธุรกรรมระหว่างสมาชิกด้วยกันเอง หรือระหว่างสมาชิกกับบุคคลภายนอก โดยมีบริการของบริษัทเป็นสื่อกลาง
        <br /> <br />⑧ บริษัทจะไม่รับผิดชอบใด ๆ หากไม่มีบทบัญญัติในกฎหมายที่เกี่ยวข้องกำหนดไว้
        <br />
        <br />⑨ หากสมาชิกละเมิดข้อกำหนดของข้อตกลงนี้และทำให้บุคคลอื่นได้รับความเสียหาย
        สมาชิกต้องรับผิดชอบในการชดใช้ค่าสินไหมทดแทน เว้นแต่จะพิสูจน์ได้ว่าไม่ได้มีเจตนาหรือความประมาทเลินเล่อ
        <br />
        <br />⑩ หากเกิดความเสียหายจากข้อมูล เอกสาร หรือเนื้อหาที่สมาชิกโพสต์หรือส่งผ่านบริการ
        หรือมีผลกระทบจากการเลือกใช้หรือไม่เลือกใช้ข้อมูลนั้น ๆ สมาชิกต้องรับผิดชอบแต่เพียงผู้เดีย
        <br />
        <br />⑪ หากบริษัทหรือสมาชิกละเมิดข้อตกลงนี้และเป็นเหตุให้คู่สัญญาได้รับความเสียหาย
        ฝ่ายที่ละเมิดจะต้องรับผิดชอบในการชดใช้ค่าสินไหมทดแทน เว้นแต่จะพิสูจน์ได้ว่าไม่ได้มีเจตนาหรือความประมาทเลินเล่อ
      </ol>
      <p>ข้อที่ 27 กฎหมายที่ใช้บังคับและเขตอำนาจศาล</p>
      <ol>
        ① ข้อพิพาทใด ๆ ที่เกิดขึ้นระหว่างบริษัทกับสมาชิก ให้อยู่ภายใต้บังคับของกฎหมายแห่งสาธารณรัฐเกาหลี
        <br /> <br />
        ② คดีความที่เกี่ยวข้องกับข้อพิพาทระหว่างบริษัทกับสมาชิก
        ให้ศาลท้องถิ่นที่มีเขตอำนาจตามที่อยู่ของสมาชิกในขณะยื่นฟ้องเป็นศาลที่มีอำนาจพิจารณาคดีโดยเฉพาะ
        หากไม่สามารถระบุที่อยู่ของสมาชิกได้ ให้ใช้ศาลที่มีอำนาจพิจารณาตามถิ่นที่อยู่ชั่วคราว (ที่พักอาศัย) แทน
        และหากไม่สามารถระบุได้ทั้งที่อยู่และถิ่นที่อยู่ชั่วคราว
        ให้กำหนดเขตอำนาจศาลตามกฎหมายวิธีพิจารณาความแพ่งแห่งสาธารณรัฐเกาหลี
        <br /> <br />③ สำหรับสมาชิกที่มีที่อยู่หรือถิ่นพำนักอยู่ในต่างประเทศ ไม่ว่ากรณีใด ๆ
        ข้อพิพาทที่เกิดขึ้นระหว่างบริษัทกับสมาชิกให้ขึ้นอยู่กับเขตอำนาจของศาลแขวงโซลกลาง ประเทศเกาหลีใต้
      </ol>
      <br />
      ©2025 BubbleTap. All rights reserved.
      {/* <p>[부칙] 이 약관은 2022년 8월 xx일부터 적용됩니다.</p> */}
    </Styled.MainWrapper>
  );
}

export default TermsOfServiceTh;
